var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m10.5 17.5c-5.5 0.8-5.5 9.2 0 10",
  fill: "none",
  stroke: "#46626d",
  strokeWidth: 1.9,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m34.5 17.5c5.5 0.8 5.5 9.2 0 10",
  fill: "none",
  stroke: "#46626d",
  strokeWidth: 1.9,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m11.5 14.5h22c1.4 0 2.5 1.1 2.5 2.5v10.4c0 1.4-1.1 2.5-2.5 2.5h-22c-1.4 0-2.5-1.1-2.5-2.5v-10.4c0-1.4 1.1-2.5 2.5-2.5z",
  fill: "#4fb3c6"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 19.1,
  width: 23,
  height: 1.5,
  rx: 0.75,
  fill: "#d6ecf2"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 26,
  width: 23,
  height: 1.5,
  rx: 0.75,
  fill: "#d6ecf2"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 18.5,
  y: 15.6,
  width: 8,
  height: 1.8,
  rx: 0.9,
  fill: "#46626d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m21.4 21.2h2.2v1.7h1.7v2.2h-1.7v1.7h-2.2v-1.7h-1.7v-2.2h1.7z",
  fill: "#ffffff"
});

function SvgFaceMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceMask);
export default __webpack_public_path__ + "static/media/face-mask.f4d746ef5b56dca783f567b1defea132.svg";
export { ForwardRef as ReactComponent };